/** wrapper for base field in the panel on Request Overview tab and Reviewer/Approver view with specific styles for panel fields */
import * as React from "react"
import PropTypes from "prop-types"
import RequestBaseFields from "containers/requests/Request/tabs/RequestOverview/RequestBaseFields/RequestBaseFields"

// apis
import { useUserSettings } from "api/hooks"

// styles
import "./RequestFieldPanelWrapper.scss"

const RequestFieldPanelWrapper = ({ request, onClick, disabled }) => {
  const { isLoading: isUserSettingsLoading } = useUserSettings()

  if (!request || isUserSettingsLoading) return null

  return (
    <div
      onClick={onClick ? onClick : null}
      className={`request-field-panel-wrapper${disabled ? " --disabled" : ""}`}
    >
      <RequestBaseFields
        requestFormData={request}
        readOnly
      />
    </div>
  )
}

RequestFieldPanelWrapper.propTypes = {
  request: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

export default RequestFieldPanelWrapper
